// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"29":"b9a2db0c","206":"781086c6","243":"7f4de3b0","354":"6aca8e37","490":"eb645a9f","687":"2c6f4e00","736":"860fefb0","833":"9dc11ed9"}[chunkId] + ".chunk.js";
};